// relative path to the image folder (/assets/imgs)
export default function usePreloadImages(images: string[]) {
  const preloadMeta = useHead({
    link: images.map((img) => ({
      rel: 'preload',
      href: img,
      as: 'image',
    })),
  })
  return preloadMeta
}
